import { BasicComponent } from "haxt";

import "./CheckoutPage.scss";

// global Stripe
declare const Stripe: any;

class StripeIntegration {
	private static stripe: any;
	private static key = "pk_test_51SbPloQ2L5Ip3XYieshSD1NJ5aRRiBJ6ov9Ww6e1FwIm1yGydFGoAN4ceXQCNlHQMfSadritgEyl6f7aigHjgNoG00eRd58C57";

	public static async getStripe() {
		if (!this.stripe) {
			// <script src="https://js.stripe.com/clover/stripe.js"></script>
			let script = document.createElement("script");
			script.src = "https://js.stripe.com/clover/stripe.js";
			document.head.appendChild(script);
			await new Promise((resolve) => {
				script.onload = () => resolve(true);
			});
			this.stripe = Stripe(this.key);
		}
		return this.stripe;
	}
}

export class CheckoutPage extends BasicComponent<{
	page: string;
	parts: string[];
}> {
	@BasicComponent.bind()
	async attachCheckout(instance: HTMLDivElement) {
		const fetchClientSecret = async () => {
			const response = await fetch("/stripe/create-checkout-session", {
				method: "POST",
			});
			const { clientSecret } = await response.json();
			return clientSecret;
		};

		let stripe = await StripeIntegration.getStripe();

		// Initialize Checkout
		const checkout = await stripe.initEmbeddedCheckout({
			fetchClientSecret,
		});

		// Mount Checkout
		checkout.mount('#checkout');
	}

	public render() {
		return (
			<div class="CheckoutPage">
				<raw id="checkout" key="checkout" ref={this.attachCheckout} />
			</div>
		);
	}
}
